export const AV_EUREKA_INIT = 'AV_EUREKA_INIT';
